/* eslint-disable no-undef */
const LIB_LIST = {
    MACOS: "viettel-ca_v6.dylib;viettel-ca_v5.dylib;viettel-ca_v4.dylib",
    WIN: "viettel-ca_v6.dll;viettel-ca_v5.dll;viettel-ca_v4.dll;viettel-ca_v2.dll",
};
const DOMAIN = "http://127.0.0.1:14007/";

const getOSName = () => {
    const ua = window.navigator.userAgent;
    if (ua.includes("Windows NT 10.0")) 
    {
        if (ua.includes("Windows 11")) return "Windows 11"; // Rất hiếm khi có chuỗi này
        if (ua.includes("Win64") && ua.includes("rv:")) return "Windows 11"; // Firefox on Win11
        return "Windows 10 or 11";
    }
    if (ua.includes("Windows NT 6.2")) return "Windows 8";
    if (ua.includes("Windows NT 6.1")) return "Windows 7";
    if (ua.includes("Windows NT 6.0")) return "Windows Vista";
    if (ua.includes("Windows NT 5.1")) return "Windows XP";
    if (ua.includes("Windows NT 5.0")) return "Windows 2000";
    if (ua.includes("Mac")) return "Mac/iOS";
    if (ua.includes("X11")) return "UNIX";
    if (ua.includes("Linux")) return "Linux";
    return "Unknown";
};

const createXHR = () =>
    window.XMLHttpRequest
        ? new XMLHttpRequest()
        : new ActiveXObject("Microsoft.XMLHTTP");

const SignatureDigitalService = {
    showErrMsg_CMS(code) {
        const map = {
            "100100": "Lỗi: Không có chứng thư số.",
            "100101": "Lỗi: Tương tác SignPlugin.",
            "100102": "Lỗi: Chứng thư số không hợp lệ hoặc không có quyền sử dụng. Vui lòng F5 lại trình duyệt và thử lại",
            "100202": "Lỗi: Chứng thư số không hợp lệ hoặc không có quyền sử dụng. Vui lòng F5 lại trình duyệt và thử lại",
            "100103": "Lỗi: Session không hợp lệ",
            "100205": "Lỗi: Session không hợp lệ",
            "100303": "Lỗi: Session không hợp lệ",
            "100104": "Lỗi: Chứng thư số hết hạn",
            "100200": "Lỗi: Dữ liệu không hợp lệ",
            "100201": "Lỗi: Không tìm thấy chứng thư số",
            "100203": "Lỗi: Lỗi trong quá trình ký",
            "100204": "Lỗi: Lỗi bộ nhớ không đủ",
            "100300": "Lỗi: Chữ ký không đúng định dạng",
            "100301": "Lỗi: Phân tích chứng thư số",
            "100302": "Lỗi: Chữ ký không hợp lệ",
        };
        return map[code] || "Lỗi: " + code;
    },

    showErrMsg_Docs(code) {
        const map = {
            "100101": "Lỗi: Chép file.",
            "100201": "Lỗi: Chép file.",
            "100301": "Lỗi: Chép file.",
            "101002": "Lỗi: Chép file.",
            "101102": "Lỗi: Chép file.",
            "100102": "Lỗi: Tài liệu bị mã hóa, không thể ký",
            "100202": "Lỗi: Tài liệu bị mã hóa, không thể ký",
            "100302": "Lỗi: Tài liệu bị mã hóa, không thể ký",
            "100103": "Lỗi: Không tìm thấy chứng thư số để ký",
            "100203": "Lỗi: Không tìm thấy chứng thư số để ký",
            "100303": "Lỗi: Không tìm thấy chứng thư số để ký",
            "100701": "Lỗi: Không tìm thấy chứng thư số để ký",
            "100802": "Lỗi: Không tìm thấy chứng thư số để ký",
            "100104": "Lỗi: Chứng thư số bị lỗi, không thể ký",
            "100204": "Lỗi: Chứng thư số bị lỗi, không thể ký",
            "100304": "Lỗi: Chứng thư số bị lỗi, không thể ký",
            "100803": "Lỗi: Chứng thư số bị lỗi, không thể ký",
            "100105": "Lỗi: Chứng thư số không hợp lệ hoặc không có quyền sử dụng. Vui lòng F5 lại trình duyệt và thử lại",
            "100205": "Lỗi: Chứng thư số không hợp lệ hoặc không có quyền sử dụng. Vui lòng F5 lại trình duyệt và thử lại",
            "100305": "Lỗi: Chứng thư số không hợp lệ hoặc không có quyền sử dụng. Vui lòng F5 lại trình duyệt và thử lại",
            "100804": "Lỗi: Chứng thư số không hợp lệ hoặc không có quyền sử dụng. Vui lòng F5 lại trình duyệt và thử lại",
            "100106": "Lỗi: Đọc file",
            "100206": "Lỗi: Đọc file",
            "100306": "Lỗi: Đọc file",
            "101003": "Lỗi: Đọc file",
            "101103": "Lỗi: Đọc file",
            "100107": "Lỗi: Lỗi trong quá trình ký",
            "100207": "Lỗi: Lỗi trong quá trình ký",
            "100307": "Lỗi: Lỗi trong quá trình ký",
            "100805": "Lỗi: Lỗi trong quá trình ký",
            "100400": "Lỗi: Định dạng file không hỗ trợ",
            "100401": "Lỗi: Định dạng file không hỗ trợ",
            "100402": "Lỗi: Tên file quá dài",
            "100403": "Lỗi: Kích thước file quá lớn",
            "100404": "Lỗi: Chưa thiết lập link upload",
            "100405": "Lỗi: Lỗi trong quá trình upload file",
            "100406": "Lỗi: Lỗi trong quá trình upload file",
            "100407": "Lỗi: Lỗi trong quá trình upload file",
            "100408": "Lỗi: Lỗi trong quá trình upload file",
            "101004": "Lỗi: Lỗi trong quá trình upload file",
            "101104": "Lỗi: Lỗi trong quá trình upload file",
            "100600": "Lỗi: Hủy chọn file",
            "100601": "Lỗi: Hủy lưu file",
            "100500": "Lỗi: Input file",
            "101001": "Lỗi: Input file",
            "101101": "Lỗi: Input file",
            "101301": "Lỗi: Input file",
            "100501": "Lỗi: Output file",
            "100502": "Lỗi: Session không hợp lệ",
            "100700": "Lỗi: Session không hợp lệ",
            "100800": "Lỗi: Session không hợp lệ",
            "101000": "Lỗi: Session không hợp lệ",
            "101100": "Lỗi: Session không hợp lệ",
            "101200": "Lỗi: Session không hợp lệ",
            "101300": "Lỗi: Session không hợp lệ",
            "100801": "Lỗi: Dữ liệu XML không đúng định dạng",
            "101201": "Lỗi: Định dạng thời gian không đúng",
            "100100": "Lỗi: Không có chứng thư số.",
            "100101": "Lỗi: Tương tác SignPlugin.",
            "100102": "Lỗi: Chứng thư số không hợp lệ hoặc không có quyền sử dụng. Vui lòng F5 lại trình duyệt và thử lại",
            "100202": "Lỗi: Chứng thư số không hợp lệ hoặc không có quyền sử dụng. Vui lòng F5 lại trình duyệt và thử lại",
            "100103": "Lỗi: Session không hợp lệ",
            "100205": "Lỗi: Session không hợp lệ",
            "100303": "Lỗi: Session không hợp lệ",
            "100104": "Lỗi: Chứng thư số hết hạn",
            "100200": "Lỗi: Dữ liệu không hợp lệ",
            "100201": "Lỗi: Không tìm thấy chứng thư số",
            "100203": "Lỗi: Lỗi trong quá trình ký",
            "100204": "Lỗi: Lỗi bộ nhớ không đủ",
            "100300": "Lỗi: Chữ ký không đúng định dạng",
            "100301": "Lỗi: Phân tích chứng thư số",
            "100302": "Lỗi: Chữ ký không hợp lệ",
        };
        return map[code] || "Lỗi: " + code;
    },

    excutePlugin() {
        window.open('./signplugin_viettel-ca_installer.exe');
    },

    async initPlugin() {
        const OSName = getOSName();
        console.log(OSName);
        if (OSName === "UNIX" || OSName === "Linux") {
            return {
                error: true,
                mess: `Không hỗ trợ hệ điều hành ${OSName}!`,
            };
        }

        return new Promise((resolve) => {
            const xmlhttp = createXHR();
            xmlhttp.onreadystatechange = function () {
                if (xmlhttp.readyState === 4) {
                    if (xmlhttp.status === 200) {
                        const response = xmlhttp.responseText;
                        if (response) {
                            resolve({ error: false, session: response });
                        } else {
                            resolve({
                                error: true,
                                mess: "Vui lòng cài đặt SignPlugin hoặc cắm Token vào máy và bấm F5 để thử lại",
                            });
                        }
                    } else {
                        resolve({
                            error: true,
                            mess: "Vui lòng cài đặt SignPlugin hoặc cắm Token vào máy và bấm F5 để thử lại",
                        });
                    }
                }
            };
            xmlhttp.open("POST", DOMAIN + "getSession", true);
            xmlhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
            if (OSName === "Mac/iOS") {
                xmlhttp.send("liblist=" + LIB_LIST.MACOS);
            } else {
                xmlhttp.send("liblist=" + LIB_LIST.WIN);
            }
        });
    },


    openFile() {
        return new Promise((resolve, reject) => {
            const reqOpen = createXHR();
            reqOpen.onreadystatechange = function () {
                if (reqOpen.readyState === 4) {
                    if (reqOpen.status === 200) {
                        resolve({
                            error: false,
                            filePath: reqOpen.responseText
                        });
                    } else {
                        reject({
                            error: true,
                            mess: `OpenFile failed with status ${reqOpen.status}`
                        });
                    }
                }
            };
            reqOpen.open("POST", DOMAIN + "OpenFile", true);
            reqOpen.send();
        });
    },

    async signPDF(inputFile, outputFile, logoFile, reason, sessionID, pageIndex, offsetX, offsetY, sigWidth, sigHeight) {
        const OSName = getOSName();
        if (OSName === "UNIX" || OSName === "Linux") {
            return {
                error: true,
                mess: `Không hỗ trợ hệ điều hành ${OSName}!`,
            };
        }

        return new Promise((resolve) => {
            const xmlhttp = createXHR();
            xmlhttp.onreadystatechange = function () {
                if (xmlhttp.readyState === 4) {
                    if (xmlhttp.status === 200) {
                        console.log("Response from signPDF:", xmlhttp.responseText);
                        if (xmlhttp.responseText == "") {
                            var ReqLastErr;
                            if (window.XMLHttpRequest) {// code for IE7+, Firefox, Chrome, Opera, Safari
                                ReqLastErr = new XMLHttpRequest();
                            }
                            else {// code for IE6, IE5
                                ReqLastErr = new ActiveXObject("Microsoft.XMLHTTP");
                            }
                            ReqLastErr.onreadystatechange = function () {
                                if (ReqLastErr.readyState == 4 && ReqLastErr.status == 200) {
                                    resolve({
                                        error: true,
                                        mess: SignatureDigitalService.showErrMsg_Docs(ReqLastErr.responseText),
                                    });
                                }
                            }
                            ReqLastErr.open("POST", DOMAIN + "getLastErr", true);
                            ReqLastErr.send();
                            return;
                        }
                        resolve(xmlhttp.responseText);
                    } else {
                        resolve({
                            error: true,
                            mess: "Không thể kết nối tới SignPlugin để ký PDF",
                        });
                    }
                }
            };
            xmlhttp.open("POST", DOMAIN + "signPDF", true);
            xmlhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
            const body =
                `inputFile=${inputFile}` +
                `&outputFile=${outputFile}` +
                `&logoFile=${logoFile}` +
                `&reason=${reason}` +
                `&sessionID=${sessionID}` +
                `&pageIndex=${pageIndex}` +
                `&offsetX=${offsetX}` +
                `&offsetY=${offsetY}` +
                `&sigWidth=${sigWidth}` +
                `&sigHeight=${sigHeight}`;
            console.log(decodeURIComponent(body));
            xmlhttp.send(decodeURIComponent(body));
        });
    },
    //(0: SHA-1; 1:MD5; 2: SHA-256)
    async signHash(hashval, hashopt = 2, sessionID) {
        const OSName = getOSName();
        if (OSName === "UNIX" || OSName === "Linux") {
            return {
                error: true,
                mess: `Không hỗ trợ hệ điều hành ${OSName}!`,
            };
        }

        return new Promise((resolve) => {
            const xmlhttp = createXHR();
            xmlhttp.onreadystatechange = function () {
                if (xmlhttp.readyState === 4) {
                    if (xmlhttp.status === 200) {
                        console.log("Response from signHash:", xmlhttp.responseText);
                        if (xmlhttp.responseText == "") {
                            var ReqLastErr;
                            if (window.XMLHttpRequest) {// code for IE7+, Firefox, Chrome, Opera, Safari
                                ReqLastErr = new XMLHttpRequest();
                            }
                            else {// code for IE6, IE5
                                ReqLastErr = new ActiveXObject("Microsoft.XMLHTTP");
                            }
                            ReqLastErr.onreadystatechange = function () {
                                if (ReqLastErr.readyState == 4 && ReqLastErr.status == 200) {
                                    resolve({
                                        error: true,
                                        mess: SignatureDigitalService.showErrMsg_Docs(ReqLastErr.responseText),
                                    });
                                }
                            }
                            ReqLastErr.open("POST", DOMAIN + "getLastErr", true);
                            ReqLastErr.send();
                            return;
                        }
                        resolve(xmlhttp.responseText);
                    } else {
                        resolve({
                            error: true,
                            mess: "Không thể kết nối tới SignPlugin để ký ",
                        });
                    }
                }
            };
            xmlhttp.open("POST", DOMAIN + "signHash", true);
            xmlhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
            const body =
                `HashVal=${hashval}` +
                `&HashOpt=0` +
                `&sessionID=${sessionID}`;
                console.log(decodeURIComponent(body));
            xmlhttp.send(decodeURIComponent(body));
        });
    },
        async getCert(sessionID) {
        const OSName = getOSName();
        if (OSName === "UNIX" || OSName === "Linux") {
            return {
                error: true,
                mess: `Không hỗ trợ hệ điều hành ${OSName}!`,
            };
        }

        return new Promise((resolve) => {
            const xmlhttp = createXHR();
            xmlhttp.onreadystatechange = function () {
                if (xmlhttp.readyState === 4) {
                    if (xmlhttp.status === 200) {
                        const response = xmlhttp.responseText;
                        if (response) {
                            resolve({ error: false, cert: response });
                        } else {
                            resolve({
                                error: true,
                                mess: "Không thể lấy certificate. Vui lòng kiểm tra Usb Token!",
                            });
                        }
                    } else {
                        resolve({
                            error: true,
                            mess: "Không thể kết nối tới SignPlugin.",
                        });
                    }
                }
            };
           xmlhttp.open("POST", DOMAIN + "getCertificate", true);
            xmlhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
            const body =`sessionID=${sessionID}`;
            xmlhttp.send(decodeURIComponent(body));
        });
    }
    
 , base64ToHex(base64) {
  const binary = atob(base64);
  let hex = '';
  for (let i = 0; i < binary.length; i++) {
    const byte = binary.charCodeAt(i);
    hex += byte.toString(16).padStart(2, '0');
  }
  return hex;
}

};


export default SignatureDigitalService;